<template>
    <q-dialog v-model="model">
        <q-card style="max-width: 90vw">
            <q-card-section>
                <div class="text-h6">Presupuestos vinculados</div>
            </q-card-section>

            <q-separator />

            <q-card-section class="scroll q-pa-none">
                <q-table
                    ref="tableRef"
                    :rows="rows"
                    :columns="columns"
                    row-key="id"
                    :loading="loading"
                    dense
                    flat
                    :pagination="pagination"
                >
                    <template v-slot:body-cell-acciones="props">
                        <q-td :props="props">
                            <q-btn
                                color="blue"
                                round
                                flat
                                icon="mdi-eye"
                                size="sm"
                                @click="show(props.row.id)"
                            >
                                <q-tooltip
                                    anchor="top middle"
                                    self="center middle"
                                >
                                    Ver presupuesto
                                </q-tooltip>
                            </q-btn>
                        </q-td>
                    </template>
                </q-table>
            </q-card-section>

            <q-separator />

            <q-card-actions align="right">
                <q-btn flat label="Cerrar" color="primary" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import ObraService from "@/services/ObraService.js";
import numberFormat from "@/helpers/numberFormat";
import { format } from "date-fns";
import { ref, watchEffect } from "vue";

const model = defineModel();
const props = defineProps({
    obra: {
        type: Number,
        required: true,
    },
});
const pagination = ref({
    page: 1,
    rowsPerPage: 50,
});

const rows = ref([]);
const loading = ref(false);
const columns = [
    { name: "id", label: "ID", field: "id", align: "left", sortable: true },
    {
        name: "vendedor",
        label: "Vendedor",
        align: "left",
        field: (val) => val.vendedor?.A3_NOME,
        sortable: true,
    },
    {
        name: "A3_XFZAVEN",
        label: "Fuerza de Venta",
        align: "left",
        field: (val) => val.vendedor?.A3_XFZAVEN,
        sortable: true,
    },
    {
        name: "user",
        label: "Usuario Carga",
        align: "left",
        field: (val) => val.user.name,
        sortable: true,
    },
    {
        label: "Fecha de Necesidad",
        name: "fecha_necesidad",
        align: "center",
        field: "fecha_necesidad",
        format: (val) => format(new Date(val), "dd/MM/yyyy"),
        sortable: true,
    },
    {
        label: "Estado",
        name: "estado",
        align: "left",
        field: (val) => val.estado.nombre,
    },
    {
        label: "Total",
        name: "total",
        align: "right",
        field: "items_sum_total",
        format: (val) => numberFormat(val),
    },
    {
        label: "Observaciones",
        name: "observaciones",
        align: "left",
        field: "observaciones",
    },
    {
        label: "",
        name: "acciones",
        align: "center",
    },
];
watchEffect(async () => {
    if (!props.obra) return;
    loading.value = true;
    try {
        rows.value = await ObraService.presupuestos(props.obra);
    } catch (error) {
        $q.notify({
            type: "negative",
            message: "Error al cargar los presupuestos",
        });
    } finally {
        loading.value = false;
    }
});
const show = (id) => {
    window.open(`/presupuestos/${id}`, "_blank");
};
</script>
